var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7461 2.42773L12.1973 0.878906C12.0449 0.726562 11.8418 0.625 11.6133 0.625H7.47461C6.56055 0.625 5.84961 1.36133 5.84961 2.25V8.75C5.875 9.66406 6.58594 10.375 7.5 10.375H12.375C13.2637 10.375 14 9.66406 14 8.75V3.01172C14 2.7832 13.8984 2.58008 13.7461 2.42773ZM12.7812 8.75C12.7812 8.97852 12.5781 9.15625 12.375 9.15625H7.47461C7.24609 9.15625 7.06836 8.97852 7.06836 8.75V2.27539C7.06836 2.04688 7.24609 1.86914 7.47461 1.86914H10.7246L10.75 3.0625C10.75 3.51953 11.1055 3.875 11.5625 3.875H12.7559V8.75H12.7812ZM7.90625 12C7.90625 12.2285 7.70312 12.4062 7.5 12.4062H2.59961C2.37109 12.4062 2.19336 12.2285 2.19336 12V5.52539C2.19336 5.29688 2.39648 5.11914 2.59961 5.11914H5.0625V3.875H2.59961C1.71094 3.875 0.974609 4.61133 0.974609 5.5L1 12C1 12.9141 1.71094 13.625 2.625 13.625H7.5C8.38867 13.625 9.125 12.9141 9.125 12V11.1875H7.90625V12Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.603258b6e2506fdcc00189a5771361d8.svg";
export { ForwardRef as ReactComponent };